export default __webpack_public_path__ + "/dist/images/5934209.f3671b7bf132e596cfdf4570e3c2d134.png";